import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function isUuidLike(value) {
  if (value === null || value === undefined) return false;
  const normalized = String(value).trim();
  if (!normalized) return false;

  if (/^[0-9a-fA-F]{32}$/.test(normalized)) return true;

  return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/.test(normalized);
}

export function formatDisplayId(value, fallback = "—") {
  if (value === null || value === undefined || value === "") return fallback;

  const normalized = String(value).trim();
  if (!normalized) return fallback;
  if (isUuidLike(normalized)) return "Hidden";
  return normalized;
}
